import React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { URL as BACKEND_URL } from '../../gql/client'
import { STORAGE_NAMES } from '../../helpers/consts'
import { useIntl } from 'react-intl'
import { HASH, TELEPHONY_MESSAGES as T } from '../../helpers/telephonyMessages'

interface Props {
  callId: number | string
  recordingId?: string
}

export const VicidialCallRecordingPlayer: React.FC<Props> = ({ callId, recordingId }) => {
  const intl = useIntl()
  const [url, setUrl] = React.useState<string | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const loadRecording = async () => {
    if (url || loading) return
    setLoading(true)
    setError(null)
    try {
      const token = localStorage.getItem(STORAGE_NAMES.TOKEN) || ''
      const response = await fetch(`${BACKEND_URL}/api/telephony/calls/${callId}/recording`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      const data = await response.json()
      if (!response.ok)
        throw new Error(data?.error || intl.formatMessage(T.errRecordingNotFound))
      if (!data?.url) throw new Error(intl.formatMessage(T.errRecordingUrlMissing))
      setUrl(data.url)
    } catch (exc: any) {
      setError(exc?.message || intl.formatMessage(T.errRecordingLoad))
    } finally {
      setLoading(false)
    }
  }

  if (url) {
    const downloadName = recordingId ? `recording-${recordingId}.mp3` : 'recording.mp3'
    return (
      <div className='mt-1 d-flex align-items-center gap-2 flex-wrap'>
        <audio controls preload='none' src={url} style={{ width: '100%', maxWidth: '320px', height: '32px' }} />
        <a
          href={url}
          download={downloadName}
          className='btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1'
          title={intl.formatMessage(T.downloadRecording)}
        >
          <i className='bi bi-download' />
          <span>{intl.formatMessage(T.download)}</span>
        </a>
      </div>
    )
  }

  return (
    <div className='mt-1 d-flex align-items-center gap-2'>
      <Button
        variant='outline-primary'
        size='sm'
        onClick={loadRecording}
        disabled={loading}
        className='d-inline-flex align-items-center gap-1'
      >
        {loading ? <Spinner animation='border' size='sm' /> : <i className='bi bi-play-circle' />}
        <span>
          {loading ? intl.formatMessage(T.loading) : intl.formatMessage(T.playRecording)}
        </span>
      </Button>
      {recordingId && <span className='text-muted small'>{HASH}{recordingId}</span>}
      {error && <span className='text-danger small'>{error}</span>}
    </div>
  )
}
